import React, { Component } from 'react';
import Navbar from '../components/Layouts/Navbar';

import ItConsultantService from '../components/ItConsultingKmu/ItConsultantService';
import Footer from '../components/Layouts/Footer';
import PageSeo from '../components/Common/PageSeo';
import ItConsultingKmuMainBanner from '../components/ItConsultingKmu/ItConsultingKMUMainBanner';
import ItConsultingEigenschaften from '../components/ItConsultingKmu/ItConsultingEigenschaften';
import ItConsultingMethods from '../components/ItConsultingKmu/ItConsultingMethods';
import ItConsultingIndustries from '../components/ItConsultingKmu/ItConsultingIndustries';
import ItConsultingProjekte from '../components/ItConsultingKmu/ItConsultingProjekte';
import ItConsultingInfoAndCTA from '../components/ItConsultingKmu/ItConsultingInfoAndCTA';
import ItConsultingFAQ from '../components/ItConsultingKmu/ItConsultingFAQ';
import ItConsultingWeitereDienstleistungen from '../components/ItConsultingKmu/ItConsultingWeitereDienstleistungen';
import SubscribeStyleOne from '../components/Common/SubscribeStyleOne';
import { useTranslations } from '../locales/useTranslations';
import { useRouter } from 'next/router';


const ItConsultingKmu = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';


    return (
        <>
            <PageSeo
                title={t('itConsulting_page_title')}
                description={t('itConsulting_page_description')}
                canonical={`${baseUrl}/it-consulting/`}
                openGraph={{
                    url: `${baseUrl}/it-consulting/`,
                    title: t('itConsulting_page_ogTitle'),
                    description: t('itConsulting_page_ogDescription'),
                    images: [
                        {
                            url: `${baseUrl}/images/simplify-data.png`,
                            width: 1200,
                            height: 1200,
                            alt: t('itConsulting_page_ogImageAlt'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('itConsulting_page_title'),
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'keywords',
                        content: t('itConsulting_page_keywords'),
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data'
                    },
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH'
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel'
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString()
                    },
                    {
                        name: 'format-detection',
                        content: 'telephone=no'
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: 'https://simplify-data.de/it-consulting/'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: 'https://simplify-data.com/it-consulting/'
                    }
                ]}
            />
            <Navbar />
            <ItConsultingKmuMainBanner />
            <ItConsultingEigenschaften />
            <ItConsultantService />
            <ItConsultingMethods />
            <ItConsultingIndustries />
            <ItConsultingInfoAndCTA />
            <ItConsultingFAQ />
            <ItConsultingWeitereDienstleistungen />
            <SubscribeStyleOne />
            <Footer />
        </>
    );
}

export default ItConsultingKmu;